import { tooltips } from '@/copy';

const clusterOrder = tooltips.clusters.map(({ value }) => value).reverse();
const getClusterOrder = (cluster) => {
    const idx = clusterOrder.indexOf(cluster);
    return idx > -1 ? idx : null;
};
const getFlavorValue = (item) =>
    item?.hierarchies
        ?.reduce((acc, [_, hierarchy]) => {
            if (hierarchy?.cat1 === 'flavors' && hierarchy?.cat4) {
                acc.push(hierarchy.cat4);
            }
            return acc;
        }, [])
        .join(', ');

const missingValue = (value) =>
    value === undefined || value === null || value === '';

const sortDataByKey = ({ ascending, data, key }) => {
    if (!data) return data;
    const isCluster = key === 'cluster';
    const isFlavor = key === 'flavors';
    return data.slice().sort((a, b) => {
        const aValue = isCluster
            ? getClusterOrder(a[key])
            : isFlavor
              ? getFlavorValue(a)
              : Array.isArray(a[key])
                ? a[key].toLocaleString()
                : a[key];
        const bValue = isCluster
            ? getClusterOrder(b[key])
            : isFlavor
              ? getFlavorValue(b)
              : Array.isArray(b[key])
                ? b[key].toLocaleString()
                : b[key];
        const switchDirection = +ascending || -1;
        if (aValue === bValue) return 0;
        // Push null or undefined items to bottom of sorts
        const aMissing = missingValue(aValue);
        const bMissing = missingValue(bValue);
        if (aMissing && bMissing) return 0;
        if (aMissing) return 1;
        if (bMissing) return -1;

        if (typeof aValue === 'string')
            return aValue.localeCompare(bValue) * switchDirection;
        if (typeof bValue === 'string')
            return bValue.localeCompare(aValue) * switchDirection;

        return (aValue - bValue) * switchDirection;
    });
};

export default sortDataByKey;
